import { adminAxiosInstance } from "./adminAxiosInstance";
import { axiosInstance } from "./axiosInstance";

const metadataCache = new Map();
const metadataRequests = new Map();

export const getMarketPricesMeta = ({ admin = false, forceRefresh = false } = {}) => {
  const cacheKey = admin ? "admin" : "public";
  const cached = metadataCache.get(cacheKey);
  if (!forceRefresh && cached) return Promise.resolve(cached);
  if (!forceRefresh && metadataRequests.has(cacheKey)) return metadataRequests.get(cacheKey);

  const request = (admin ? adminAxiosInstance : axiosInstance)
    .get(admin ? "/admin/internal/ops/market-prices/meta" : "/market-prices/meta")
    .then(({ data }) => {
      if (data?.status === false) throw new Error(data.message || "Market price metadata could not be loaded.");
      metadataCache.set(cacheKey, data);
      return data;
    })
    .finally(() => metadataRequests.delete(cacheKey));

  metadataRequests.set(cacheKey, request);
  return request;
};

export const clearMarketPricesMetaCache = ({ admin } = {}) => {
  if (typeof admin === "boolean") metadataCache.delete(admin ? "admin" : "public");
  else metadataCache.clear();
};
